import { Map } from 'immutable';
import { types as buildsTypes } from '@saucelabs/sl-module-builds';

import * as rdcTypes from './../rdc/types';
import * as vdcTypes from './../vdc/types';

export const initialState = Map({
  loading: true,
});

const buildsReducer = (state = initialState, { type }) => {
  switch (type) {
    case buildsTypes.BUILD_GET.SUCCESS:
    case rdcTypes.rdcBuildsListV2Types.BUILD_GET.SUCCESS:
    case vdcTypes.vdcBuildsListV2Types.BUILD_GET.SUCCESS:
      return state.set('loading', false);
    case rdcTypes.rdcBuildsDetailV2Types.CLEANUP:
    case vdcTypes.vdcBuildsDetailV2Types.CLEANUP:
      return state.set('loading', true);
    default:
      return state;
  }
};

export default buildsReducer;
